import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiLabelComponent } from './eui-label.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiLabelComponent],
    declarations: [EuiLabelComponent],
})
export class EuiLabelModule {
}
